import moment from 'moment'
import { API_DATE_FORMAT, HUMAN_READABLE_DATE_FORMAT, VUETIFY_DATE_FORMAT } from '../const'

export default class DateAdapter {
  #date
  #format

  constructor(date, format) {
    this.#date = date
    this.#format = format

    if (!moment(date, format, true).isValid()) {
      throw new Error(`Invalid date: ${date} with format: ${format}`)
    }
  }

  toHumanReadable() {
    return moment(this.#date, this.#format).format(HUMAN_READABLE_DATE_FORMAT)
  }

  toApiSupportedFormat() {
    return moment(this.#date, this.#format).format(API_DATE_FORMAT)
  }

  toUiSupportedFormat() {
    return moment(this.#date, this.#format).format(VUETIFY_DATE_FORMAT)
  }
}
